import { HOW_DIMENSION_COLOR, HOW_DIMENSION_TITLE } from '@/lib/howDimensions';
import type { GCLDimension } from '@/types/dojo';

/** The same dimension identity as Your HOW, never a progress indicator. */
export function PracticeDimensionLabel({ dimension }: { dimension?: GCLDimension | null }) {
  if (!dimension || !HOW_DIMENSION_TITLE[dimension]) return null;

  return (
    <span className="mb-2 flex items-center gap-2 text-xs font-normal leading-5 text-how-text-secondary">
      <span
        className="h-2 w-2 shrink-0 rounded-full ring-1 ring-inset ring-how-space-deep/10"
        style={{ backgroundColor: HOW_DIMENSION_COLOR[dimension] }}
        aria-hidden="true"
      />
      {HOW_DIMENSION_TITLE[dimension]}
    </span>
  );
}
